module.exports = __webpack_public_path__ + "static/02-f70f020b1ddf7e355d257c3a0f83f184.jpg";